// extracted by mini-css-extract-plugin
module.exports = {"root":"ForJournalistsScreen_root__2BQDV","leftCol":"ForJournalistsScreen_leftCol__wfAJv","description":"ForJournalistsScreen_description__2pW1e","actionHolder":"ForJournalistsScreen_actionHolder__VMxwx","rightCol":"ForJournalistsScreen_rightCol__5h-sX","slider":"ForJournalistsScreen_slider__3qZnq","siteImage":"ForJournalistsScreen_siteImage__28wnq"};
    if(module.hot) {
      // 1586964019288
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  